module.exports = __webpack_public_path__ + "img/logo-CRM.b52f75e6.svg";